import React from "react";
import TimeAgo from "react-timeago";
import { cleanDate } from "../../../util/app";

function CorrespondenceList({ items = [] }) {
    if (items && items.length < 1)
        return (
            <div className="text-center text-pink m-t-20">
                <i className="material-icons" style={{ fontSize: "2em" }}>
                    info
                </i>
                <br />
                <strong>No Attachment has been added yet</strong>
            </div>
        );
    return (
        <div className="no-pad table-responsive">
            <table className="table table-bordered table-hover">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Date Created</th>
                        <th className="text-center">Download</th>
                    </tr>
                </thead>
                <tbody>
                    {items &&
                        items.map((item, index) => (
                            <tr key={index}>
                                <td className="inbox-small-cells">
                                    <div className="todo-check pull-left">{index + 1}</div>
                                </td>
                                <td className="view-message">
                                    <span>{item.name}</span>
                                    <br />
                                    <small className="text-muted">
                                        <TimeAgo date={item.datetime}></TimeAgo>
                                    </small>
                                </td>
                                <td className="view-message">{item.desc}</td>
                                <td className="view-message">{cleanDate(item.datetime, true, false)}</td>

                                <td className="view-message text-center">
                                    <button
                                        onClick={() => {
                                            document.location.href = item.path;
                                        }}
                                        title="Download"
                                        className="mdl-button mdl-button--icon mdl-button--colored btn-default"
                                    >
                                        <i className="material-icons text-primary">cloud_download</i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );
}

export default CorrespondenceList;
